import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

export interface MedicationExtractionFeedbackCriteria {
  btSpanId: string;
  suggestionRelevancy: number;
  erroneousSuggestions?: boolean;
  comment?: string | null;
}

export const useMedicationExtractionFeedback = ({
  patientId,
  encounterId,
}: {
  patientId: string;
  encounterId: string;
}) => {
  return useApiMutation<void, MedicationExtractionFeedbackCriteria>({
    mutationOptions: {
      mutationKey: [
        "apothra-feedback-medication-extraction",
        patientId,
        encounterId,
      ],
      mutationFn: async (payload: MedicationExtractionFeedbackCriteria) => {
        await axiosInstance.post(
          "/rx/apothra/feedback/questionnaire-medication-extraction",
          payload,
        );
      },
    },
  });
};
